export enum TraceAction {
    PAGE_EVENT = 'PAGE_EVENT',
    ERROR = 'ERROR',
  }